export default __webpack_public_path__ + "static/media/fusion360.9620a93f.png";